import { SalesOrderItemType } from '../../../constants/sales-order-item-type.js';
/** TOT-3: an order has at most one Shipping and one Discount adjustment. This is the only place that rule lives, so DISC-A4 can relax it for Discount here. */
export const SINGLE_ADJUSTMENT_KINDS = new Set([
    SalesOrderItemType.SHIPPING,
    SalesOrderItemType.DISCOUNT,
]);
/** The positions in `typeIds` that repeat a single-kind adjustment already seen earlier. */
export function duplicateSingleAdjustmentKinds(typeIds) {
    const seen = new Set();
    const duplicates = [];
    typeIds.forEach((typeId, index) => {
        if (!SINGLE_ADJUSTMENT_KINDS.has(typeId))
            return;
        if (seen.has(typeId))
            duplicates.push({ index, typeId });
        seen.add(typeId);
    });
    return duplicates;
}
//# sourceMappingURL=single-adjustment-kinds.js.map